import { cn } from "@/lib/utils/general"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "motion-safe:animate-shimmer-subtle motion-reduce:bg-white/[0.04] rounded-md",
        "bg-gradient-to-r from-white/[0.02] via-white/[0.06] to-white/[0.02]",
        "bg-[length:1000px_100%]",
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
